import ReactDOM from "react-dom";
import { typeShell } from "../styles/typeShell";

function UploadingOverlay({
    message = "メディアをアップロード中です。画面を閉じないでください。",
    totalFiles = 0,
    completedFiles = 0,
    currentFileName = null,
    overallProgress = 0
}) {
    const progressPercentage = totalFiles > 0
        ? Math.round((completedFiles / totalFiles) * 100)
        : overallProgress;

    return ReactDOM.createPortal(
        <div className="pointer-events-auto fixed inset-0 z-[9999] h-screen w-screen bg-white/85">
            <div className="absolute left-1/2 top-1/2 w-full min-w-[25rem] max-w-[31.25rem] -translate-x-1/2 -translate-y-1/2 rounded-xl bg-surface px-8 py-6 text-center shadow-none">
                <div
                    className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-[5px] border-solid border-ui-muted border-t-button-primary motion-reduce:animate-none"
                    aria-hidden="true"
                />
                <p className={`mb-6 mt-0 font-bold ${typeShell.body}`}>
                    {message}
                </p>

                {totalFiles > 0 && (
                    <div className="mt-6">
                        <div className={`mb-2 flex items-center justify-between ${typeShell.body}`}>
                            <span className="text-text-muted">
                                {completedFiles} / {totalFiles} ファイル完了
                            </span>
                            <span className="font-bold text-button-primary">
                                {progressPercentage}%
                            </span>
                        </div>
                        <div className="mb-3 h-2 w-full overflow-hidden rounded bg-border-subtle">
                            <div
                                className="h-full rounded bg-gradient-to-r from-button-primary to-button-primary-hover transition-[width] duration-300 ease-in-out"
                                style={{ width: `${progressPercentage}%` }}
                            />
                        </div>
                        {currentFileName && (
                            <p className={`m-0 mt-2 overflow-hidden text-ellipsis whitespace-nowrap ${typeShell.muted}`}>
                                アップロード中: {currentFileName}
                            </p>
                        )}
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
}

export default UploadingOverlay;
